import { PropsWithChildren } from 'react';

import { css } from '@emotion/react';

export const Link = ({
  id,
  href,
  children,
  ...rest
}: PropsWithChildren<{ id?: string; href?: string }>) => {
  if (!href) {
    return <div {...rest}>{children}</div>;
  }

  return (
    <a
      id={id}
      href={href}
      css={css`
        display: block;
        user-select: none;
        cursor: pointer;
        text-decoration: none;

        &:hover {
          background-color: #f7f9fc;
        }
      `}
      target="_blank"
      rel="noreferrer"
      {...rest}
    >
      {children}
    </a>
  );
};
